import React, { memo, PropsWithChildren, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getFeatureFlags } from 'utils/feature-flags';

import styles from './SkipLink.scss';

type SkipLinkProps = {
  destination: string;
};

const SkipLink = memo(({ destination, children = null }: PropsWithChildren<SkipLinkProps>) => {
  const ref = useRef<HTMLAnchorElement>(null);
  const { pathname } = useLocation();

  const flagged = !!getFeatureFlags().enableSkipLinkFocusOnRouteChange;

  useEffect(() => {
    if (flagged && ref.current && ref.current.focus) {
      ref.current.focus();
    }
  }, [flagged, pathname]);

  return (
    <a ref={ref} className={styles.skipLink} data-testid="skipLink" href={destination}>
      {children}
    </a>
  );
});

export default SkipLink;

SkipLink.displayName = 'SkipLink';
